module.exports = __webpack_public_path__ + "assets/sentry.48556ae2.svg";